<script setup lang="ts">
</script>

<template>
    <div class="settings-head">
        <h1 class="settings-head__left">
            {{ $route.name }}
        </h1>
        <slot />
    </div>
</template>

<style lang="scss" scoped>
.settings-head {
    position: relative;

    &__left {
        font-size: 26px;
        line-height: 34px;
        font-weight: 600;
        text-transform: capitalize;
        margin: 0 0 32px;

        @include breakpoint(black-bear) {
            margin-bottom: 9px;
        }
    }
}
</style>
